import { render, staticRenderFns } from "./RChart.vue?vue&type=template&id=f51f27c0&"
import script from "./RChart.vue?vue&type=script&lang=js&"
export * from "./RChart.vue?vue&type=script&lang=js&"
import style0 from "./RChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports